import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typogaphy from "../Typography/Typography";
import { useCloseTicket } from "../../hooks/useManagement";
const initvalue = {
  ticket_id: null,
};
export const CloseTicketModal = ({
  show,
  handleClose,
  ticketId,
  chatsRefetch,
}) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initvalue);
  const { mutateAsync: closeCurrentTicket } = useCloseTicket();
  const handleCloseTicket = async (data) => {
    await closeCurrentTicket(data).then(() => chatsRefetch());
  };

  useEffect(() => {
    setForm({ ...form, ticket_id: ticketId });
  }, [ticketId]);

  return (
    <BootstrapModal
      modaltitle="بستن تیکت"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <Typogaphy className="mb-2">
          آیا از بستن این تیکت مطمئن هستید؟
        </Typogaphy>

        <div className="col-6">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleCloseTicket(form);
              handleClose();
            }}
          >
            بله
          </Button>
        </div>
        <div className="col-6">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
